import { render, staticRenderFns } from "./ActivitiesTable.vue?vue&type=template&id=5303659a&scoped=true&"
import script from "./ActivitiesTable.vue?vue&type=script&lang=js&"
export * from "./ActivitiesTable.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesTable.vue?vue&type=style&index=0&id=5303659a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5303659a",
  null
  
)

export default component.exports